import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const parsePlan = (p) => {
  const parts = (p.description || '').split('\n\n');
  const features = [];
  parts.slice(1).forEach((seg) =>
    seg.split('\n').forEach((line) => {
      const t = line.trim();
      if (t.startsWith('•')) features.push(t.replace(/^•\s*/, ''));
    })
  );
  return { ...p, tagline: parts[0] || '', parsedFeatures: features };
};

export const usePlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/plans`)
      .then((r) => setPlans((r.data.plans || []).map(parsePlan)))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return { plans, loading, error };
};

// Live API plans when available; otherwise the official localized tiers.
export const useResolvedPlans = () => {
  const { t } = useTranslation();
  const { plans: apiPlans } = usePlans();
  const staticPlans = t('plans', { returnObjects: true }).map((p) => ({
    ...p,
    currency: 'USD',
    parsedFeatures: p.features,
  }));
  const plans = apiPlans.length > 0 ? apiPlans : staticPlans;
  return { plans, live: apiPlans.length > 0 };
};
